
import MapOverlay from '@/components/MapOverlay.vue'
import PronosticoMeteorologicoFooter from '@/components/PronosticoMeteorologicoFooter.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { PronosticoLocalMapasState } from '@/store/modules/pronostico-local-mapas/types'
import { createArray } from '@/components/helpers/timelineArray'
import { validateImageType } from '@/components/helpers/setPronosticoMeteorologicoOverlay'
import DesktopFooter from '@/components/DesktopFooter.vue'
import { preloadImages } from '@/components/helpers/preloadImages'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

const PRONOSTICO_METEOROLOGICO = 'pronosticoLocalMapas'
const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    MapOverlay,
    DesktopFooter,
    PronosticoMeteorologicoFooter
  }
})
export default class PronosticoLocalMapas extends Vue {
  @State(PRONOSTICO_METEOROLOGICO)
  public pronosticoLocalMapas!: PronosticoLocalMapasState
  @Action('getPronosticoLocalMapas', { namespace: PRONOSTICO_METEOROLOGICO })
  private getPronosticoLocalMapas: any
  @Action('setOverlayViews', { namespace: GOOGLE_MAPS_MODULE })
  private setOverlayViews: any
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  @Prop() type!: string
  @Prop() vector!: string
  private timelineList: any[] = []
  private currentPosition: number = 0
  private baseImageUrl: string = env.url.IMG

  get computedTimelineList () {
    if (this.pronosticoLocalMapas.delta > 0) this.timelineList = createArray(this.pronosticoLocalMapas)
    return this.timelineList
  }

  setOverlays ({ position }: { position: number }) {
    if (validateImageType(this.type) && this.pronosticoLocalMapas.pasos > 0) {
      const overlays: any[] = []
      const currentItem = position
      const { ruta, latlong, imagenes } = this.pronosticoLocalMapas
      const bounds = {
        south: latlong[0][0],
        north: latlong[1][0],
        west: latlong[0][1],
        east: latlong[1][1]
      }

      imagenes[this.type].forEach((image: string, index: number) => {
        const srcImage = `${this.baseImageUrl}${ruta}/${image}`

        overlays.push({
          bounds,
          image: srcImage,
          isShown: currentItem === index
        })
      })
      this.currentPosition = currentItem
      this.setOverlayViews(overlays)
    }
  }

  getData () {
    // Get the data from the store
    return this.getPronosticoLocalMapas()
  }

  async created () {
    await this.getData()
    preloadImages(this.baseImageUrl, this.pronosticoLocalMapas)
    const position = {
      lat: this.pronosticoLocalMapas.centro[0],
      lng: this.pronosticoLocalMapas.centro[1]
    }
    const zoom = env.settings.PRONOSTICO_LOCAL.zoom
    this.setPosition({ position, zoom })
  }

  beforeDestroy () {
    this.setOverlayViews([])
  }
}
